import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

const SelectInput = React.forwardRef((props, ref) => {
  const {
    containerCls = "",
    inputProps = {},
    label,
    error,
    options = [],
    formInput,
    defaultValue,
  } = props;

  const { name, validation } = formInput;
  const [optionvalue, setOptionvalue] = useState({});

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const optionval = options?.filter(
      (option) => option.label === defaultValue
    );
    setOptionvalue(optionval);
    console.log("Default:", optionval);
  }, [options]);

  useEffect(() => {
    reset(optionvalue);
  }, [optionvalue]);
  return (
    <div className={`my-4 ${containerCls}`}>
      {label ? <div className="pb-1 text-gray-800">{label}</div> : null}
      <Controller
        name={name}
        control={inputProps?.control}
        defaultValue={optionvalue}
        rules={validation}
        render={({ field }) => {
          return <Select {...field} options={options} />;
        }}
      />
      {error ? (
        <div className="pt-1.5 text-red-600 text-sm">{error}</div>
      ) : null}
    </div>
  );
});

export default SelectInput;
